<template>
  <div v-if="personId">
    <v-progress-linear v-if="loading" :indeterminate="true" />

    <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div>

    <v-list dense>
      <v-textarea
        v-model="newCommentText"
        auto-grow
        full-width
        append-icon="send"
        rows="1"
        solo
        label="Leave a Comment"
        clearable
        @click:append="submitComment"
        @keyup.ctrl.enter="submitComment"
      >
        <template v-slot:prepend-inner>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                v-if="newCommentType"
                @click="newCommentType = !newCommentType"
                >R</v-btn
              >

              <v-btn
                icon
                v-else
                v-on="on"
                @click="newCommentType = !newCommentType"
              >
                A
              </v-btn>
            </template>

            <span v-if="newCommentType">Registrar Comment</span>
            <span v-else>Admin Comment</span>
          </v-tooltip>
        </template>
      </v-textarea>

      <template v-for="(comment, index) in allComments">
        <v-list-item
          class="comment"
          :key="comment.commentid"
          :class="{
            registrarComment: comment.commenttype,
            adminComment: !comment.commenttype
          }"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ comment.createdate | formatDate }}
              <br />
              <em>
                {{ comment.createdby }}
              </em>
            </v-list-item-title>
            {{ comment.comment }}
            <br />
            <small>
              -
              {{ comment.commenttype ? "Registrar " : "Admin" }}
              Comment
            </small>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="index"></v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "CommentList",
  data() {
    return {
      errors: [],
      newCommentType: false,
      newCommentText: ""
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup", loading: "isLoading" }),
    allComments() {
      return this.$store.getters.getById(this.personId)?.comments || [];
    }
  },
  methods: {
    loadResources() {
      if (!this.personId) {
        return;
      }
      this.$store.dispatch("load", this.personId);
      // this.loading = true;
      // var reqs = [];

      // reqs.push(
      //   this.$http
      //     .get("/pcomments", {
      //       params: {
      //         filter: {
      //           where: { personid: this.personId },
      //           order: "commentid desc"
      //         }
      //       }
      //     })
      //     .then(response => {
      //       this.loading = false;
      //       this.allComments = { ...response.data };
      //       this.errors = [];
      //     })
      //     .catch(e => {
      //       this.loading = false;
      //       this.handleError(e);
      //     })
      // );
    },
    handleError(e) {
      this.errors.push(e.message);
    },
    async submitComment(ev) {
      console.log(this.newCommentText, this.newCommentType);
      if (!this.newCommentText) {
        return;
      }
      try {
        let comment = await this.$http.post("/pcomments", {
          comment: this.newCommentText,
          personid: this.personId,
          commenttype: this.newCommentType
        });
      } finally {
        this.loadResources(this.personId);
        this.loading = false;
        this.newCommentText = "";
      }
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadResources"
    }
  }
};
</script>

<style>
.registrarComment {
  background-color: #ffe8f0;
  font-style: italic;
}
.comment > div {
  height: unset !important;
  padding: 1em;
}
</style>
